export default "__VITE_ASSET__Dc_cz9Hh__"